import React from 'react';
import CommentCard from './CommentCard';

/**
 * @typedef {object} CommentListProps
 * @property {Array<*>} [comments]
 * @property {number} [selectedCommentId]
 * @property {number} [focusedCommentId]
 * @property {Object} [focusedCommentRef]
 * @property {(id: number) => void} editComment
 * @property {(id: number) => void | Promise<void>} deleteComment
 */

/**
 * @param {CommentListProps} props
 */
const CommentList = props => {
  const {
    comments = [],
    selectedCommentId = 0,
    focusedCommentId = 0,
    focusedCommentRef,
    editComment,
    deleteComment
  } = props;

  return (
    <div className='comment-list' data-testid='comment-list'>
      {!comments.length && <h3 className='no-data'>No Comments</h3>}
      {comments.length > 0 &&
        comments.map(comment => (
          <CommentCard
            key={comment.id}
            selectedCommentId={selectedCommentId}
            focusedCommentId={focusedCommentId}
            focusedCommentRef={focusedCommentRef}
            comment={comment}
            editComment={editComment}
            deleteComment={deleteComment}
          />
        ))}
    </div>
  );
};

export default CommentList;
